
import { default as app, collapsibleHeaderClickEvent, onWindowResize, IsUndefinedOrNull} from '@legacy/App';




app.factory('AuditLogFactory', ['$http', 'settings', function ($http, settings) {
    return {       
        getAuditLogDetails: function (id) {
            return $http.get(settings.ApiURL + settings.AuditLogURL + "/" + id);
        },       
        getEntityList: function () {
            return $http.get(settings.ApiURL + settings.AuditLogURL + '/entitylist');
        },
        getFilteredAuditLogList: function (filterOptions) {
            return $http.put(settings.ApiURL + settings.AuditLogURL + '/filter', filterOptions);
        }
    };
}]);

app.controller('AuditLogController', ['$scope', 'AuditLogFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal',
        function ($scope, AuditLogFactory, $rootScope, settings, masterFactory, $uibModal) {
    $rootScope.pageTitle = "Audit Log";
    $scope.AuditLogs = [];
    $scope.AuditLog = {};
    $scope.TotalCount = null;
    $scope.filterOptions = {
        TableName: null, LogType: null, Username: null, DateFrom: null, DateTo: null,
        GridPagerOptions: { PageIndex: 0, PageSize: 2, TotalPages: null }
    };
    $scope.ObjectKeys = [];
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.PageSize = 20;

    var getAuditLog = function (id) {
        AuditLogFactory.getAuditLogDetails(id).success(function (data) {
            $scope.AuditLog = data;
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    var auditGridDataSource = {
        store: new DevExpress.data.CustomStore({
            // DataSource Configuration
            pageSize: $scope.PageSize,
            // Data Access Logic
            load: function(loadOptions) {
                var d = $.Deferred();
                var params = {};

                if (loadOptions != undefined) {
                    $scope.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? $scope.PageSize : loadOptions.take;
                    $scope.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);                    
                }
                AuditLogFactory.getFilteredAuditLogList($scope.filterOptions).success(function (data) {
                    d.resolve(data.AuditLogList, { totalCount: data.TotalCount });
                    $scope.TotalCount = data.TotalCount;
                }).error(function (data, status) {
                    //$scope.AuditLogs = [];
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {                    
                });

                return d.promise();
            },
            byKey: function(key, extra) {
                // . . .
            },
            update: function(values) {
                // . . .
            }
        })
    };

    // Grid renderers
    $scope.refreshGrid = function (Key) {
        $('#gridAuditLog').dxDataGrid({
            columns: [
                { caption: 'Audit Log Id', dataField: 'Id', dataType: 'number', alignment: 'center' },
                { caption: 'Log Date', dataField: 'LogDate', dataType: 'date', format: 'dd/MM/yyyy HH:mm', alignment: 'center' },
                { caption: 'Log Type', dataField: 'LogType', dataType: 'string', alignment: 'center' },
                { caption: 'Table Name', dataField: 'TableName', dataType: 'string', alignment: 'center' },
                { caption: 'User', dataField: 'UserName', dataType: 'string', alignment: 'center' }
            ],
            contentReadyAction: grdReadyAction,
            dataSource: auditGridDataSource,
            filterRow: { visible: false },
            groupPanel: { visible: false },
            noDataText: "No Audit Logs Found",
            paging: { pageSize: $scope.PageSize },
            pager: { visible: true, allowedPageSizes: [10, 20, 30], showPageSizeSelector: true },
            rowAlternationEnabled: false,
            selection: { mode: 'single' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.AuditLog = selectedRowsInfo.selectedRowsData[0];
                    getObjectKeys();                    
                }                
                $scope.isFormVisible = true;                
            },
            scrolling: { mode: 'standard' },
            showBorders: true,
            showColumnLines: true,
            showRowLines: false,
            sorting: { mode: 'none' }
        });

        if (Key != null && Key > 0) {
            var dataGrid = $('#gridAuditLog').dxDataGrid('instance');
            (dataGrid as unknown as FacnmDx).selectRows([Key]);
        }
    };

    // Button click functions 
    $scope.cancelForm = function () {
        var dataGrid = $('#gridAuditLog').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;        
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.filterAuditLogs = function (filterOptions) {        
        $scope.closeAlert();
        $scope.closeModelStateErrors();        
        $scope.filterOptions = angular.copy(filterOptions);
        var dataGrid = $('#gridAuditLog').dxDataGrid('instance');
        dataGrid.refresh();        
    };

    $scope.viewFilterOptionsModal = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'app-legacy/Entities/templates/filterOptionsModal.html',
            controller: 'FilterOptionsModalController',
            controllerAs: 'modalVm',
            size: 'lg',
            scope: $scope
        });

        modalInstance.result.then(function (transferData) {
            $scope.filterAuditLogs(transferData.filterOptions);
            $scope.cancelForm();
            if(transferData.action == 'reset')
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Filter options reset successfully' });
            else
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Filter options applied successfully' });
        }, function () {

        });
    };

    function grdReadyAction(e) {        
        onWindowResize('#gridAuditLog', 185);
    }

    // Helping functions and events
    function getObjectKeys() {
        if ($scope.AuditLog != null) {
            if ($scope.AuditLog.OldValue != null) {
                $scope.ObjectKeys = Object.keys($scope.AuditLog.OldValue);
            }
            if ($scope.ObjectKeys.length == 0) {
                if ($scope.AuditLog.NewValue != null) $scope.ObjectKeys = Object.keys($scope.AuditLog.NewValue);
            }
        }
    }

    $(window).resize(function () {        
        onWindowResize('#gridAuditLog', 185);
    });


    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    // Initialization - this runs on load
    var init = function () {        
        masterFactory.verifyAuthentication();        
        $scope.refreshGrid(null);
    };

    init();
}]);

app.controller('FilterOptionsModalController', ['$scope', '$filter', 'AuditLogFactory', '$uibModalInstance', '$uibModal', 'masterFactory',
    function ($scope, $filter, AuditLogFactory, $uibModalInstance, $uibModal, masterFactory) {
        var modalVm = this;

        init();

        modalVm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        modalVm.closeAlert = function () {
            modalVm.error = "";
        };

        modalVm.closeModelStateErrors = function () {
            modalVm.modelState = [];
        };

        modalVm.resetfilterOptions = function () {
            modalVm.filterOptions = {
                TableName: null, LogType: null, Username: null, DateFrom: null, DateTo: null,
                GridPagerOptions: { PageIndex: 0, PageSize: 2, TotalPages: null }
            };
            modalVm.transferData.filterOptions = angular.copy(modalVm.filterOptions);
            modalVm.transferData.action = "reset";
            $uibModalInstance.close(modalVm.transferData);
        };

        modalVm.filterAuditLogs = function () {
            if (modalVm.filterOptionsForm.$valid) {
                modalVm.transferData.filterOptions = angular.copy(modalVm.filterOptions);
                modalVm.transferData.action = "filter";
                $uibModalInstance.close(modalVm.transferData);                
            }
        };

        function init() {
            modalVm.error = "";
            modalVm.modelState = [];
            modalVm.entityList = [];
            modalVm.filterOptions = {
                TableName: null, LogType: null, Username: null, DateFrom: moment(), DateTo: moment(),
                GridPagerOptions: { PageIndex: 0, PageSize: 2, TotalPages: null }
            };
            modalVm.transferData = { filterOptions: null, action: null };
            AuditLogFactory.getEntityList().success(function (data) {
                modalVm.entityList = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, modalVm);
            });
        };
}]);